/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiVisitorAdapter } from '../../visitors/AaiVisitorAdapter';

/**
 * An AsyncAPI 2.0 visitor adapter.
 * 
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 * @extends AaiVisitorAdapter
 */
export class Aai20VisitorAdapter extends AaiVisitorAdapter implements IAai20Visitor {
    constructor() {
        super();
    }
}
Aai20VisitorAdapter["__class"] = "io.apicurio.datamodels.asyncapi.v2.visitors.Aai20VisitorAdapter";
Aai20VisitorAdapter["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor"];





import { IAai20Visitor } from './IAai20Visitor';

